import React from 'react'
import { categoryData as CData } from '../../../data/category.data';
import { familyData as FData } from '../../../data/family.data';
import {individualData as IData} from '../../../data/individual.data';

import logoUmbra from './../../../UI/canvas/umbra-logo-grey.svg'

interface Props{
    selectedCategory: string,
    selectedFamily: string,
    selectedIndividual: string,
    handleSelectedCategory: any
    handleSelectedFamily: any,
    handleSelectedIndividual: any,
    isSidebarOpened: any,
    handleOpenBar: any
}

interface State{
    CategoryData: any,
    FamilyData: any,
    IndividualData: any,
    iOSDevice: boolean
}

class Sidebar extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            CategoryData: CData(),
            FamilyData: FData(),
            IndividualData: IData(),
            iOSDevice: false
        }
    }

    handleGetCategory = () => {
        return(
            this.state.CategoryData.map((data: any, index: number) =>
                <div 
                    className='individual-category-container' 
                    key = {index} 
                    onClick={() => {this.props.handleSelectedCategory(this.props.selectedCategory === data.Nombre ? "":data.Nombre)}}
                >
                    <img src={data.Imagen}></img>
                    <div className={this.props.selectedCategory === data.Nombre ? 'text-category-selected':'text-category'}>{data.Nombre}</div>
                </div>
            )
        )
    }

    handleGetFamily = () => {
        if(this.props.selectedCategory !== ""){
            return(
                this.state.FamilyData[0][this.props.selectedCategory].map((data: any, index: number) =>
                    <div 
                        className='individual-category-container' 
                        key={index} 
                        onClick={() => {this.props.handleSelectedFamily(this.props.selectedFamily === data.Nombre ? "":data.Nombre)}}
                        id='element-umbra-analytics' data-value={data.Nombre} data-type={"MODELO"} 
                    >
                        <img id='element-umbra-analytics' data-value={data.Nombre} data-type={"MODELO"} src={data.Imagen}></img>
                        <div id='element-umbra-analytics' data-value={data.Nombre} data-type={"MODELO"} className={this.props.selectedFamily === data.Nombre ? 'text-category-selected':'text-category'}>{data.Nombre}</div>
                    </div>
                )
            )
        }
    }

    handleGetIndividual = () => {
        if(this.props.selectedFamily !== "" && this.props.selectedCategory !== "HÍBRIDOS" && this.props.selectedCategory !== "PERFORMANCE"){
            return(
                this.state.IndividualData[0][this.props.selectedFamily + " " +this.props.selectedCategory].map((data: any, index: number) =>
                    <div 
                        className='individual-category-container' 
                        key={index}
                        onClick={() => {this.props.handleSelectedIndividual(this.props.selectedIndividual === data.Nombre ? "":data.Nombre)}}
                        id='element-umbra-analytics' data-value={this.props.selectedFamily} data-second={data.Nombre} data-type={"VERSION"} 
                    >
                        <img id='element-umbra-analytics' data-value={this.props.selectedFamily} data-second={data.Nombre} data-type={"VERSION"} src={data.Imagen}></img>
                        <div id='element-umbra-analytics' data-value={this.props.selectedFamily} data-second={data.Nombre} data-type={"VERSION"} className={this.props.selectedIndividual === data.Nombre ? 'text-category-selected':'text-category'}>{data.Nombre}</div>
                    </div>
                )
            )
        }
    }

    render(): React.ReactNode {
        return(
            <div 
            className={this.props.isSidebarOpened ? 'sidebar-main-opened':'sidebar-main'}
            style={{
                pointerEvents : this.props.isSidebarOpened ? "visibleFill":"none"
            }}
            >
                <div 
                    className={this.props.isSidebarOpened ? 'sidebar-btn-opened':'sidebar-btn'} 
                    onClick={() => {this.props.handleOpenBar()}}
                    style = {{pointerEvents: "all"}}
                >
                    <div className={this.props.isSidebarOpened ? 'top-bar-opened':'top-bar-collapsed'}/>
                    <div className={this.props.isSidebarOpened ? 'middle-bar-opened':'middle-bar-collapsed'}/>
                    <div className={this.props.isSidebarOpened ? 'bottom-bar-opened':'bottom-bar-collapsed'}/>
                </div>

                <div className={this.props.isSidebarOpened ? 'info-container fade-in':'info-container fade-out'}>
                        <div className='info-category'>
                            VEHÍCULOS
                        </div>
                        <div className='info-hr'/>
                    </div>
                <div className={this.props.isSidebarOpened ? 'category-container fade-in':'category-container fade-out'}>
                    {
                        this.handleGetCategory()
                    }
                </div>

                <div className={this.props.isSidebarOpened && this.props.selectedCategory ? 'info-container-family fade-in':'info-container-family fade-out'}>
                        <div className='info-category'>
                            {this.props.selectedCategory !== "" ? this.props.selectedCategory : ""}
                        </div>
                        <div className='info-hr'/>
                </div>
                <div className={this.props.isSidebarOpened && this.props.selectedCategory !== "" ? 'family-container fade-in':'family-container fade-out'}>
                    {
                        this.handleGetFamily()
                    }
                </div>

                <div className={this.props.isSidebarOpened && this.props.selectedFamily  && this.props.selectedCategory !== "HÍBRIDOS" && this.props.selectedCategory !== "PERFORMANCE" ? 'info-container-individual fade-in':'info-container-individual fade-out'}>
                        <div className='info-category'>
                            {this.props.selectedFamily !== "" ? this.props.selectedFamily : ""}
                        </div>
                        <div className='info-hr'/>
                </div>
                <div className={this.props.isSidebarOpened && this.props.selectedFamily !== "" && this.props.selectedCategory !== "HÍBRIDOS" && this.props.selectedCategory !== "PERFORMANCE" ? 'individual-container fade-in':'individual-container fade-out'}>
                    {
                        this.handleGetIndividual()
                    }
                </div>

                <div className={this.props.isSidebarOpened ? 'umbra-logo-container fade-in':'umbra-logo-container fade-out'}>
                    <div className='umbra-text'>
                        Powered by:
                    </div>
                    <a href="https://umbraint.com/" target={"_blank"}><img src={logoUmbra}/></a>
                </div>
            </div>
        )
    }
}

export default Sidebar